import React, { useState } from 'react';

import { AutoComplete, Select } from 'antd';

const IconClear = require('assets/resources/Clear.svg').default;
const EyeVisibilityOff = require('assets/resources/EyeVisibilityOff.svg').default;
const EyeVisibilityOn = require('assets/resources/EyeVisibilityOn.svg').default;
const IconSearch = require('assets/resources/Search.svg').default;

const { Option } = Select;

const Input = (props) => {
  const {
    type = 'text',
    className = '',
    classNameInput = '',
    classNameInputOption = '',
    popupClassName = '',
    list = [],
    invalid = false,
    allowClear = false,
    onClickClear = () => {},
    onClickSearch = () => {},
    children = <></>,
    ...rest
  } = props;
  const [showPassword, setShowPassword] = useState(false);

  const handleType = () => {
    if (['search'].includes(type)) return 'text';
    else if (type === 'password' && showPassword) return 'text';
    return type;
  };

  let iconClear = <img onClick={onClickClear} className="cursor-pointer" src={IconClear} alt="icon clear" width={12} height={12} />;
  let icon = null;

  if (props.icon) {
    icon = <div className="h-full w-10 absolute top-0 right-0 flex-middle-center cursor-pointer">{props.icon}</div>;
  }

  if (type === 'search') {
    icon = (
      <div
        onClick={onClickSearch}
        className="h-full w-10 absolute top-0 right-0 flex-middle-center border border-solid border-gray-300 cursor-pointer hover:bg-gray-200"
      >
        <img src={IconSearch} alt="icon search" width={14} height={14} />
      </div>
    );
  }

  if (type === 'password') {
    icon = (
      <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute right-3 bottom-3">
        {showPassword ? (
          <img src={EyeVisibilityOn} alt="eye visibility on" width={14} height={14} />
        ) : (
          <img src={EyeVisibilityOff} alt="eye visibility off" width={14} height={14} />
        )}
      </button>
    );
  }

  if (type === 'dropdown') {
    return (
      <div className={`w-100 h-10 relative ${className}`}>
        <Select
          {...rest}
          allowClear={allowClear}
          defaultValue={props.defaultValue || list?.[0]?.value}
          classNames={{ popup: { root: popupClassName } }}
          onChange={props.onChange}
          onClear={onClickClear}
          className={(() => {
            let _class = `w-full h-full focus:outline-none placeholder:text-base placeholder:text-secondary-354 border border-solid px-3 py-2 bg-white ${classNameInput}`;
            if (invalid) {
              _class += ' border-danger-229';
            } else {
              _class += ' border-gray-651';
            }

            return _class;
          })()}
        >
          {list?.map((item, index) => (
            <Option className={item.divider ? 'mb-1 option-divider' : ''} key={`dropdown-${index}`} value={item.value}>
              <div className={`flex items-center gap-2 ${classNameInputOption}`}>
                {item.icon && item.icon}
                {item.text}
              </div>
            </Option>
          ))}
        </Select>
      </div>
    );
  }

  if (type === 'radio-cus') {
    return (
      <label htmlFor={props.id} className={`text-base text-black/85 radio-button flex items-center gap-2 w-100 relative ${className}`}>
        <input className="w-4 h-4" type="radio" {...rest} checked={props.checked} />
        <span className="checkmark"></span>
        {props.text}
      </label>
    );
  }

  if (type === 'textarea') {
    return (
      <div className={`w-100 min-h-10 relative ${className}`}>
        <textarea
          type={handleType()}
          className={`resize-none w-full h-full focus:outline-none placeholder:text-base placeholder:text-secondary-354 border border-solid ${invalid ? 'border-danger-229' : 'border-gray-651'} px-3 py-2 ${classNameInput} ${icon ? 'pr-11' : ''}`}
          {...rest}
        />
      </div>
    );
  }

  if (type === 'autocomplete') {
    return (
      <div className={`w-100 min-h-10 relative ${className}`}>
        <AutoComplete
          className={(() => {
            let _class = 'w-full h-full focus:outline-none placeholder:text-secondary-354 border border-solid px-3 py-2 rounded-sm';

            if (icon) {
              _class += ' pr-11';
            } else if (allowClear) {
              _class += ' !pr-4';
            }
            if (type === 'password' && !showPassword) {
              _class += ' tracking-1.5';
            }
            if (invalid) {
              _class += ' border-danger-229';
            } else {
              _class += ' border-gray-651';
            }
            if (classNameInput) {
              _class += ' ' + classNameInput;
            }

            return _class;
          })()}
          {...rest}
        />
        {allowClear && props.value && (
          <button className={`${icon ? 'right-10' : 'right-0'} h-full w-8 absolute top-0 flex-middle-center`}>{iconClear}</button>
        )}
      </div>
    );
  }

  const handleStyle = () => {
    let pr = props.inputPaddingRight || 0;
    if (allowClear) {
      pr += 33;
    }
    if (icon) {
      pr += 30;
    }

    return {
      paddingRight: `${pr}px`,
    };
  };

  const handleInputClass = () => {
    let _class = 'w-full h-full focus:outline-none placeholder:text-secondary-354 border border-solid px-3 py-2 rounded-sm';

    if (type === 'password' && !showPassword) {
      _class += ' tracking-1.5';
    }
    if (invalid) {
      _class += ' border-danger-229';
    } else {
      _class += ' border-gray-651';
    }
    if (classNameInput) {
      _class += ' ' + classNameInput;
    }

    return _class;
  };

  const handleInput = () => {
    return <input type={handleType()} style={handleStyle()} className={handleInputClass()} {...rest} />;
  };

  if (type === 'checkbox' || type === 'radio') {
    return (
      <label className={`w-100 h-10 relative ${className}`} htmlFor={props.id}>
        {handleInput()}
        {children}
        <span className="checkmark"></span>
      </label>
    );
  }

  return (
    <div className={`w-100 h-10 relative ${className}`}>
      {handleInput()}
      {allowClear && props.value && <button className={`${icon && 'right-10'} h-full w-8 absolute top-0 flex-middle-center`}>{iconClear}</button>}
      {icon}
      {children}
    </div>
  );
};

export default React.memo(Input);
